<template>
  <section class="sidebar--content">
    <div v-if="!sidebarContent">
      <!--      <div class="sidebar&#45;&#45;item" @click="changeContent('rent')">-->
      <!--        <div>{{ $t('general.rent') }}</div>-->
      <!--        <img src="@/assets/img/icons/arrow-right.svg" alt="Arrow Right" />-->
      <!--      </div>-->
      <!--      <div class="sidebar&#45;&#45;item" @click="changeContent('buy')">-->
      <!--        <div>{{ $t('general.buy') }}</div>-->
      <!--        <img src="@/assets/img/icons/arrow-right.svg" alt="Arrow Right" />-->
      <!--      </div>-->
      <!--      <div class="sidebar&#45;&#45;item" @click="goToPage('/kalkulator')">-->
      <!--        <div>{{ $t('general.mortgage') }}</div>-->
      <!--      </div>-->
      <!--      <div class="sidebar&#45;&#45;item" @click="goToPage('/mitra-agen')">-->
      <!--        <div>{{ $t('general.agentPartner') }}</div>-->
      <!--      </div>-->
      <!--      <div class="sidebar&#45;&#45;item" @click="goToPage('/mitra-proyek')">-->
      <!--        <div>{{ $t('general.developerPartner') }}</div>-->
      <!--      </div>-->
      <!--      <div class="sidebar&#45;&#45;item" @click="goToPage('/project/add')">-->
      <!--        {{ $t('general.addProperty') }}-->
      <!--      </div>-->
      <!--      <div class="sidebar&#45;&#45;item" @click="goToPage('/help')">-->
      <!--        {{ $t('footer.company.helpCenter') }}-->
      <!--      </div>-->
      <!--      <div class="sidebar&#45;&#45;item" @click="changeContent('search')">-->
      <!--        <div>Temukan</div>-->
      <!--        <img src="@/assets/img/icons/arrow-right.svg" alt="Arrow Right" />-->
      <!--      </div>-->
      <section v-if="loggedIn" class="sidebar--menu-section">
        <div class="sidebar--section-title">Menu</div>
        <div class="sidebar--menu-list">
          <div class="sidebar--item" @click="goToPage('/product')">
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon">
                <img src="@/assets/icons/menus/beli-paket.svg" alt="Beli Paket" />
              </span>
              <span>{{ $t('home.sidebarMenu.product') }}</span>
            </div>
          </div>
          <div class="sidebar--item" @click="goToPage('/')">
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon">
                <img src="@/assets/icons/menus/listing-saya.svg" alt="Listing Saya" />
              </span>
              <span>{{ $t('home.sidebarMenu.myListing') }}</span>
            </div>
          </div>
          <div
            v-if="enableRecommendedListing"
            class="sidebar--item"
            @click="goToPage('/recommended-listing')"
          >
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon"><v-icon>mdi-star-circle-outline</v-icon></span>
              {{ $t('home.sidebarMenu.recommendedListing') }}
              <span class="new--counter-sidebar is-child">{{ $t('general.new') }}</span>
            </div>
          </div>
          <div class="sidebar--item" @click="goToPage('/order')">
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon">
                <img src="@/assets/icons/menus/pembelian-saya.svg" alt="Pembelian Saya" />
              </span>
              <span>{{ $t('home.sidebarMenu.myOrder') }}</span>
            </div>
          </div>
          <div class="sidebar--item" @click="goToPage('/coin-purchase')">
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon">
                <img src="@/assets/icons/menus/coin-saya.svg" alt="Koin Saya" />
              </span>
              <span>{{ $t('home.sidebarMenu.myCoin') }}</span>
            </div>
          </div>
          <div class="sidebar--item sidebar--featured-trigger" @click="changeContent('featured')">
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon is-featured"><v-icon>mdi-apps</v-icon></span>
              <span>Fitur Unggulan</span>
              <span class="new--counter-sidebar is-child is-shiny">BARU</span>
            </div>
            <v-icon class="sidebar--item-next">mdi-chevron-right</v-icon>
          </div>
        </div>
      </section>

      <!--        <div class="sidebar&#45;&#45;item" @click="goToPage('/shortlist')">-->
      <!--          <div>{{ $t('home.sidebarMenu.shortlist') }}</div>-->
      <!--        </div>-->
      <section class="sidebar--menu-section">
        <div class="sidebar--section-title">Lainnya</div>
        <div class="sidebar--menu-list">
          <div v-if="loggedIn" class="sidebar--item" @click="goToPage('/leads')">
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon"><v-icon>mdi-email-outline</v-icon></span>
              <span style="position: relative; width: fit-content"> Kotak Pesan </span>
              <span v-if="enquiriesUnreadCount" class="unread--counter sidebar--unread-counter">
                {{ enquiriesUnreadCount }}
              </span>
            </div>
          </div>
          <a
            href="https://komunitas.belirumah.co"
            target="_blank"
            rel="noopener"
            class="sidebar--item"
          >
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon"><v-icon>mdi-account-group-outline</v-icon></span>
              <span>Komunitas</span>
            </div>
          </a>
          <div class="sidebar--item" @click="goToPage('/iklan-properti')">
            <div class="sidebar--item-content">
              <span class="sidebar--item-icon"><v-icon>mdi-bullhorn-outline</v-icon></span>
              <span>Iklan Properti</span>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div v-if="sidebarContent === 'buy'">
      <!--      <div class="sidebar&#45;&#45;item-title">-->
      <!--        {{ $t('general.buyHouse') }}-->
      <!--      </div>-->
      <div
        class="sidebar--item"
        v-for="(item, index) in propertyTypes"
        :key="`residential-${index}`"
        @click="goToSearch(item.id)"
      >
        {{ item.name }}
      </div>
    </div>
    <div v-else-if="sidebarContent === 'featured'" class="sidebar--featured-page">
      <button type="button" class="sidebar--content-back" @click="backToRoot">
        <v-icon>mdi-arrow-left</v-icon>
        <span>Fitur Unggulan</span>
      </button>
      <div
        v-for="item in featuredSidebarMenus"
        :key="item.url"
        class="sidebar--feature-item"
        @click="goToPage(item.url)"
      >
        <div class="sidebar--feature-icon">
          <img :src="item.iconSrc" :alt="item.label" />
        </div>
        <div class="sidebar--feature-copy">
          <div class="sidebar--feature-title">
            {{ item.label }}
            <span v-if="item.isNew" class="new--counter-sidebar is-child is-shiny">BARU</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="sidebarContent === 'search'"></div>
  </section>
</template>

<script>
import auth from '@/mixins/auth.js';
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'sidebar-content',
  mixins: [auth],
  data: () => ({
    propertyTypesResidential: [],
    propertyTypesCommercial: [],
  }),
  computed: {
    ...mapState({
      loggedIn: (state) => state.global.loggedIn,
      sidebarContent: (state) => state.global.sidebarContent,
      propertyTypes: (state) => state.masters.propertyTypes,
      enquiriesUnreadCount: (state) => state.global.enquiriesUnreadCount,
      enableRecommendedListing: (state) => state.global.enableRecommendedListing,
    }),
    ...mapGetters({
      isProOrExecutive: 'global/isProOrExecutive',
    }),
    featuredSidebarMenus() {
      const menus = [
        {
          label: this.$t('home.sidebarMenu.featuredAgent'),
          url: '/layanan-agen/agen-properti-pilihan',
          iconSrc: require('@/assets/icons/featured-features/agen-pilihan.svg'),
        },
        {
          label: this.$t('home.sidebarMenu.agenNaikKelas'),
          url: '/layanan-agen/agen-naik-kelas',
          iconSrc: require('@/assets/icons/featured-features/agen-naik-kelas.svg'),
          isNew: true,
        },
      ];

      if (this.isProOrExecutive) {
        menus.push(
          {
            label: this.$t('home.sidebarMenu.ownerConnect'),
            url: '/layanan-agen/owner-connect',
            iconSrc: require('@/assets/icons/featured-features/owner-connect.svg'),
          },
          {
            label: this.$t('home.sidebarMenu.projectConnect'),
            url: '/layanan-agen/project-connect',
            iconSrc: require('@/assets/icons/featured-features/project-connect.svg'),
            isNew: true,
          },
        );
      }

      return menus;
    },
  },
  methods: {
    changeContent(name) {
      this.$store.commit('global/SET_SIDEBAR_CONTENT', name);
      this.getPropertyTypes();
    },
    backToRoot() {
      this.$store.commit('global/SET_SIDEBAR_CONTENT', null);
    },
    async getPropertyTypes() {
      await this.$store.dispatch('masters/getPropertyTypes');
    },
    async goToSearch(propertyTypeId) {
      try {
        this.$store.commit('global/SET_MAIN_SIDEBAR', false);
        this.$store.commit('global/SET_SIDEBAR_CONTENT', null);
        let propertyType = await this.propertyTypes.find(function (item) {
          return item ? item.id === parseInt(propertyTypeId) : false;
        });
        if (propertyType) propertyType = JSON.parse(JSON.stringify(propertyType));
        this.$store.commit(
          'v2/search/SET_SELECTED_PROPERTY_TYPE',
          propertyType ? propertyType : null,
        );
        await this.$store.dispatch('v2/search/goToSearchPage', {
          router: this.$router,
          params: this.$route.params,
          query: {},
        });
      } catch (e) {
        console.log('ERROR GOING TO SEARCH PAGE: ', e);
      }
    },
    goToPage(route) {
      this.$store.commit('global/SET_MAIN_SIDEBAR', false);
      this.$store.commit('global/SET_SIDEBAR_CONTENT', null);
      this.$router.push(route);
    },
  },
};
</script>
